/**
 * AI Auto-Archiver & Stale Link Scanner
 * Detects inactive, untouched, and unvisited bookmarks for archival
 */

export function findStaleBookmarks(bookmarks = [], thresholdDays = 90) {
  const now = Date.now();
  const thresholdMs = thresholdDays * 24 * 60 * 60 * 1000;

  return bookmarks.filter((b) => {
    // Keep favorites, pinned, reading list
    if (b.pinned || b.isFavorite) return false;
    const note = (b.note || '').toLowerCase();
    if (note.includes('#reading') || note.includes('#active') || note.includes('#archive')) return false;

    // Check visit count
    const clicks = b.clicks || 0;
    if (clicks > 5) return false;

    // Check last visited or createdAt
    const lastActive = b.lastVisited || b.createdAt || 0;
    if (!lastActive) {
      // If never visited and zero clicks, considered stale candidate
      return clicks === 0;
    }

    return (now - lastActive) > thresholdMs;
  });
}

export function calculateLibraryStaleness(bookmarks = []) {
  if (bookmarks.length === 0) return { staleCount: 0, stalePercentage: 0 };
  const stale = findStaleBookmarks(bookmarks);
  return {
    staleCount: stale.length,
    stalePercentage: Math.round((stale.length / bookmarks.length) * 100),
    staleItems: stale,
  };
}
